import { render, staticRenderFns } from "./InputChavePix.vue?vue&type=template&id=0bf49018"
import script from "./InputChavePix.vue?vue&type=script&lang=js"
export * from "./InputChavePix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports